export default "__VITE_ASSET__4fd9be44__"